const COPY = {
  en: {
    close: "Close",
    section: "Section",
    roll: "Roll",
    live: "Live",
    absent: "Absent",
    payment: "Payment",
    emergency: {
      title: "Emergency alerts",
      active: "Active alert",
      location: "Location",
      raised: "Raised",
      empty: "No active emergency alerts.",
    },
    profile: {
      title: "Child profile",
      description: "View linked child profile details.",
      admissionNo: "Admission no.",
      status: "Status",
      dateOfBirth: "Date of birth",
      gender: "Gender",
      admissionDate: "Admission date",
      previousSchool: "Previous school",
    },
    statuses: {
      active: "Active",
      enrolled: "Enrolled",
      inactive: "Inactive",
      withdrawn: "Withdrawn",
      transferred: "Transferred",
      issued: "Issued",
      partially_paid: "Partially paid",
      overdue: "Overdue",
      paid: "Paid",
      success: "Success",
      failed: "Failed",
      cancelled: "Cancelled",
      initiated: "Initiated",
    },
    methods: {
      online: "Online",
      cash: "Cash",
      bank_transfer: "Bank transfer",
      pos: "POS",
      cheque: "Cheque",
      neft: "NEFT",
    },
    genders: {
      male: "Male",
      female: "Female",
      other: "Other",
    },
  },
  ar: {
    close: "إغلاق",
    section: "الشعبة",
    roll: "الرقم",
    live: "مباشر",
    absent: "غائب",
    payment: "الدفع",
    emergency: {
      title: "تنبيهات الطوارئ",
      active: "تنبيه نشط",
      location: "الموقع",
      raised: "وقت التنبيه",
      empty: "لا توجد تنبيهات طوارئ نشطة.",
    },
    profile: {
      title: "ملف الطفل",
      description: "عرض تفاصيل الطفل المرتبط بالحساب.",
      admissionNo: "رقم القبول",
      status: "الحالة",
      dateOfBirth: "تاريخ الميلاد",
      gender: "الجنس",
      admissionDate: "تاريخ القبول",
      previousSchool: "المدرسة السابقة",
    },
    statuses: {
      active: "نشط",
      enrolled: "مسجل",
      inactive: "غير نشط",
      withdrawn: "منسحب",
      transferred: "منقول",
      issued: "صادرة",
      partially_paid: "مدفوعة جزئياً",
      overdue: "متأخرة",
      paid: "مدفوعة",
      success: "ناجحة",
      failed: "فاشلة",
      cancelled: "ملغاة",
      initiated: "بدأت",
    },
    methods: {
      online: "عبر الإنترنت",
      cash: "نقداً",
      bank_transfer: "تحويل مصرفي",
      pos: "نقطة بيع",
      cheque: "شيك",
      neft: "NEFT",
    },
    genders: {
      male: "ذكر",
      female: "أنثى",
      other: "آخر",
    },
  },
};

export const guardianCopyFor = (language) => COPY[language] || COPY.en;

export const localizedGuardianValue = (language, values, value) => {
  const copy = guardianCopyFor(language);
  return copy[values]?.[value] || value?.replaceAll("_", " ") || "-";
};

export default COPY;
